import { changePasswordComponent } from './change-password.component';

export const changePassword = angular
	.module('components.auth.changePassword', [])
	.component('changePassword', changePasswordComponent)
	.config(($stateProvider) => {
		'ngInject';

		$stateProvider
		.state('app.dashboard.changePassword', {
			url: '/dashboard/change-password',
			component: 'changePassword',
			breadcrumbName: 'change password',
			parentState: 'dashboard'
		});
	})
	.name;


// WEBPACK FOOTER //
// ./src/app/components/auth/change-password/change-password.module.js